import { stringSchema, objectSchema } from '@/schemas'

export const inviteSchema = objectSchema({
  email: stringSchema.email(),
  role: stringSchema,
})
